// extracted by mini-css-extract-plugin
var _1 = "lAyr9JowZsiD9mxhwI6C";
export { _1 as "breadCrumb" }
